import {Component, Inject, OnInit} from '@angular/core';
import {Regra} from "../../../regra/regra";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DatePipe, DecimalPipe} from "@angular/common";

@Component({
    selector: 'app-modal-regra-composta',
    templateUrl: './modal-regra-composta.component.html',
    styleUrls: ['./modal-regra-composta.component.scss']
})
export class ModalRegraCompostaComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) readonly  data: Regra,
                readonly decimalPipe: DecimalPipe,
                readonly datePipe: DatePipe) {
    }

    ngOnInit(): void {

        if (typeof this.data.parametros === 'string') {
            this.data.parametros = JSON.parse(this.data.parametros);
        }
    }

    treatDate(value) {
        return this.datePipe.transform(value, 'dd/MM/yyyy')
    }

    treatDecimals(value: number) {
        return this.decimalPipe.transform(value, '1.2-2', 'pt');
    }
}
